import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { autoLinkedIlokSelector, dismissAutoLinkedIlok } from "../redux/globalSlice"
import { ilokIconWhite } from "./widgets/pillIcons"

// The one-time notice for iLok accounts the backend linked on its own: an
// iLok.com account registered to this account's verified email is linked
// on the first app load that finds it (/me returns what it linked), and
// its eligible licenses become native ones at once. Same shape and
// lifetime as ClaimedOrdersBanner: rides above every page until dismissed
// or followed, nothing to remember — the linking itself happens once.
export default function AutoLinkedIlokBanner() {
  const linked = useSelector(autoLinkedIlokSelector)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  if (linked.length === 0) return null

  const dismiss = () => dispatch(dismissAutoLinkedIlok())
  const names = linked.map((a, i) => (
    <Fragment key={a.ilokId}>
      {i > 0 && (i === linked.length - 1 ? " and " : ", ")}
      <strong>{a.ilokId}</strong>
    </Fragment>
  ))
  const issued = linked.reduce((n, a) => n + a.issued, 0)
  const onLicenses = location.pathname === "/licenses"
  const onAccount = location.pathname === "/account"

  return (
    <div className="notice-banner" role="status">
      {/* the WHITE wordmark on the Library's outline chip, not the off-white
          notice-banner-icon chip the stroke icons sit on — white on off-white
          would vanish, and the Licenses page already shows the mark this way */}
      <span className="library-ilok-bind notice-banner-ilok" aria-hidden="true">{ilokIconWhite}</span>
      <span className="notice-banner-text">
        {linked.length === 1
          ? <>We linked your iLok account {names}, which is registered to your email address.</>
          : <>We linked your iLok accounts {names}, which are registered to your email address.</>}
        {" "}
        {issued === 0
          ? "No eligible iLok licenses were found on it yet — anything that arrives later is picked up automatically."
          : issued === 1
            ? "One license has been added to your account."
            : `${issued} licenses have been added to your account.`}
      </span>
      <div className="notice-banner-actions">
        {issued > 0 && !onLicenses && (
          <button className="btn-upgrade" onClick={() => { dismiss(); navigate("/licenses") }}>
            View licenses
          </button>
        )}
        {issued === 0 && !onAccount && (
          <button className="btn-upgrade" onClick={() => { dismiss(); navigate("/account") }}>
            Account page
          </button>
        )}
        <button className="notice-banner-dismiss" onClick={dismiss} aria-label="Dismiss" title="Dismiss">
          &times;
        </button>
      </div>
    </div>
  )
}
